import Favorites from "../components/Favorites";

const favorites = new Favorites({routes:{}});

export default favorites;